import { render } from "./TableBody.vue?vue&type=template&id=68f1cc71&scoped=true&ts=true"
import script from "./TableBody.vue?vue&type=script&lang=ts"
export * from "./TableBody.vue?vue&type=script&lang=ts"

import "./table-body.scss?vue&type=style&index=0&id=68f1cc71&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f1cc71"]])

export default __exports__